import { ClientsSessionService } from '@shared/services/client-session.service';
import { ModuleUrlBuilder } from './../utils/module-url.util';
import {
  IModuleConfig,
  ModuleCode,
  ModuleType,
} from '@app/core/models/project-config.model';

const moduleUtil = new ModuleUrlBuilder(new ClientsSessionService());

export const modulesConfig: IModuleConfig[] = [
  {
    code: ModuleCode.DigitalMailbox,
    name: 'Digital Mailbox',
    imagePath: 'Icon Digital Postbox.png',
    type: ModuleType.Internal,
    urlPath: moduleUtil.digitalMailbox,
    useApiConfigValue: false,
    permissions: ['SYS_ADMIN', 'USE_DIGITAL_MAILBOX'],
    serviceCode:'DIGITAL_MAILBOX',
    description: 'ระบบรับ-ส่งเอกสารอิเล็กทรอนิกส์ ช่วยให้ผู้ใช้งานสามารถส่ง หรือรับข้อความดิจิทัล',
    submenu: [
      {id : 1,name: 'All Mails', url: '/digitalmailbox/inbox-document/INBOX'},
      {id : 2,name: 'Starred Mails', url: '/digitalmailbox/inbox-document/Favorite'},
      {id : 3,name: 'Mail Drafts', url: '/digitalmailbox/inbox-document/Drafts'},
      {id : 4,name: 'Sent Mails', url: '/digitalmailbox/inbox-document/Sent'},
      {id : 5,name: 'Trash', url: '/digitalmailbox/inbox-document/Trash'},
    ]
    // "All Mails": "All Mails",
    // "Starred Mails": "Starred Mails",
    // "Mail Drafts": "Mail Drafts",
    // "Sent Mails": "Sent Mails",
    // "Trash": "Trash"
  },
  {
    code: ModuleCode.DigitalSignature,
    name: 'Digital Signature',
    imagePath: 'Icon Digital Signature.png',
    type: ModuleType.External,
    urlPath: moduleUtil.digitalSignature,
    useApiConfigValue: true,
    permissions: ['SYS_ADMIN', 'USE_SIGNING_HUB'],
    serviceCode: 'DIGITAL_SIGNATURE',
    description: 'ระบบลงลายมือชื่ออิเล็กทรอนิกส์ช่วยให้ผู้ใช้งานลงลายมือชื่ออิเล็กทรอนิกส์ในเอกสารโดยใช้ใบรับรองอิเล็กทรอนิกส์​ซึ่งสามารถตรวจสอบความมั่นคง ปลอดภัยของเอกสารหลังลงลายมือชื่อได้',
    submenu: []
  },
  {
    code: ModuleCode.DocumentManagement,
    name: 'Drive',
    imagePath: 'Icon Document Management.png',
    type: ModuleType.External,
    urlPath: moduleUtil.documentManagement,
    useApiConfigValue: false,
    permissions: ['SYS_ADMIN', 'USE_DOCUMENT_MGMT'],
    serviceCode: 'DOCUMENT_MANAGEMENT',
    description: 'ระบบบริหารจัดเก็บเอกสาร ช่วยให้ผู้ใช้งานสามารถบริหารจัดการเอกสารต่างๆ ได้ด้วยตนเอง',
    submenu: []
  },
  {
    code: ModuleCode.EBilling,
    name: 'Electronic Billing',
    imagePath: 'Icon e-Billing.png',
    type: ModuleType.Internal,
    urlPath: moduleUtil.billingSystem,
    useApiConfigValue: false,
    permissions: ['SYS_ADMIN', 'USE_E_BILLING'],
    serviceCode: 'EBILLING',
    description: 'ระบบ E-Billing ช่วยให้ผู้ใช้งานสามารถเรียกดู และชำระค่าบริการต่างๆ จากอุปกรณ์มือถือได้อย่างง่ายดาย',
    submenu: []
  },
  // {
  //   code: ModuleCode.ConsentManagement,
  //   name: 'Consent Management',
  //   imagePath: 'e-Consent.png',
  //   type: ModuleType.Internal,
  //   urlPath: moduleUtil.consentManagement,
  //   useApiConfigValue: false,
  //   permissions: ['SYS_ADMIN', 'USE_CONSENT_MGMT'],
  // },
  {
    code: ModuleCode.PrintAndPost,
    name: 'Print and Post',
    imagePath: 'Icon Print & post.png',
    type: ModuleType.External,
    urlPath: moduleUtil.printAndPost,
    useApiConfigValue: false,
    permissions: ['SYS_ADMIN','USE_PRINT_AND_POST'],
    serviceCode: 'PRINT_AND_POST',
    submenu: []
  },
  {
    code: ModuleCode.SystemSetting,
    name: 'System Setting',
    imagePath: 'Icon System Setting.png',
    type: ModuleType.Internal,
    urlPath: moduleUtil.settings,
    useApiConfigValue: false,
    permissions: ['SYS_ADMIN', 'USE_SYSTEM_SETTING'],
    description: 'ให้บริการจัดการข้อมูลผู้ใช้งาน',
    submenu: []
  },
  {
    code: ModuleCode.EPaymentConfig,
    name: 'Electronic Payment Config',
    imagePath: 'Icon e-payment.png',
    type: ModuleType.Internal,
    urlPath: moduleUtil.paymentSystem,
    useApiConfigValue: false,
    permissions: ['SYS_ADMIN'],    
    submenu: []
  },
  {
    code: ModuleCode.PublicRelation,
    name: 'Public Relation',
    imagePath: 'Icon Public relation.png',
    type: ModuleType.External,
    urlPath: moduleUtil.publicRelation,
    useApiConfigValue: false,
    permissions: ['SYS_ADMIN','USE_PUBLICRELATION'],
    description: 'ระบบจัดการข้อมูลประชาสัมพันธ์',
    submenu: [] 
  },
  {
    code: ModuleCode.Helpdesk,
    name: 'Helpdesk',
    imagePath: 'Icon Help desk.png',
    type: ModuleType.External,
    urlPath: moduleUtil.helpdesk,
    useApiConfigValue: false,
    permissions: ['SYS_ADMIN','USE_HELPDESK'],
    description: 'ระบบที่ให้บริการให้ความช่วยเหลือเกี่ยวกับการใช้งานระบบของผู้ใช้บริการ',
    submenu: []
  },
  {
    code: ModuleCode.AdminDashboard,
    name: 'Admin Dashboard',
    imagePath: 'Admin Dashboard.png',
    type: ModuleType.Internal,
    urlPath: moduleUtil.adminDashboardSystem,
    useApiConfigValue: false,
    permissions: ['ADMIN_MARKETING'],
    submenu: []
  },
  {
    code: ModuleCode.ConfigBill,
    name: 'Config Bill',
    imagePath: 'Config Bill.png',
    type: ModuleType.Internal,
    urlPath: moduleUtil.configBillSystem,
    useApiConfigValue: false,
    permissions: ['ADMIN_MARKETING'],
    submenu: []
  },
  // {
  //   code: ModuleCode.MyService,
  //   name: 'My Service',
  //   imagePath: 'My Service.png',
  //   type: ModuleType.Internal,
  //   urlPath: moduleUtil.myServiceSystem,
  //   useApiConfigValue: false,
  //   permissions: ['MY_SERVICE'],  
  // }
];
